import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { StyledOption } from "./StyledOption";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const Option = props => {
  const {
    className,
    innerRef,
    children,
    isDisabled,
    isFocused,
    isSelected
  } = props;
  return /*#__PURE__*/React.createElement(StyledOption, _extends({
    className: className,
    ref: innerRef
    // TODO optionHeight should be moved to the LayoutContext.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    ,
    height: props.selectProps.optionHeight,
    isDisabled: isDisabled,
    isFocused: isFocused,
    isSelected: isSelected
  }, props.innerProps), children);
};
//# sourceMappingURL=Option.js.map